<script setup lang="ts">
import { PostFilterBy } from '@/blog/domain/PostFilterBy';
import { ref, watch } from 'vue';

interface Emits {
  (e: 'update:filterBy', filterBy: PostFilterBy): void;
}

interface Props {
  filterBy: PostFilterBy;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const filterBy = ref(props.filterBy);

const filterByOptions = [
  { label: 'Popular', value: PostFilterBy.POPULARITY },
  { label: 'Recent', value: PostFilterBy.RECENT },
];

watch(filterBy, value => emit('update:filterBy', value));

</script>

<template>
  <label
    v-for="opt in filterByOptions"
    :key="opt.value"
    class="flex items-center gap-2 cursor-pointer select-none"
  >
    <span class="w-5 h-5 rounded-full border-2 border-blue-600 flex items-center justify-center">
      <span
        v-if="filterBy === opt.value"
        class="w-3 h-3 rounded-full bg-blue-600"
      />
    </span>

    <input
      type="radio"
      class="hidden"
      :value="opt.value"
      v-model="filterBy"
    />

    <span class="text-blue-700 font-medium text-2xl">
      {{ opt.label }}
    </span>
  </label>
</template>
